export class SuperTabsXl {
  id?: string;
  header: string;
  index?: number;
  iconBase64?: string;
  icon?: string;
  extra?: string;
  count?: number;
}
